<template>
  <div class="row bg-white max-height-vertical max-height-auto box-overflow">
    <full-span-slide v-bind:active="active">
      
      <p class="large" v-html="title"></p>
      <p class="utility bump-down-12-mobile"><strong>Click</strong> the correct answer before proceeding to the <strong>'Next'</strong> button.</p>

      <div class="row span-16-lg">
        <radio-span v-for="option in content.options" v-bind:key="option.index" v-bind:strong="option.strong" v-bind:correct="option.correct" v-bind:caption="option.caption" :title="option.title"></radio-span>
      </div>

    </full-span-slide>
  </div>
</template>

<script>
  import full_span_slide from '../../components/organisms/full_span_slide'
  import radio_span from '../../components/molecules/radio_span'

  import {is_active} from '../../utils/is_active'

  import 'nodelist-foreach-polyfill'; // ie11

  export default {
    props: ['title', 'content', 'active'],
    components: {
      'full-span-slide': full_span_slide,
      'radio-span': radio_span
    },
    methods: {
      conditional () {
        return this.active && !this.$store.state.checkbox.el
      },
    },
    watch: {
      active () {
        is_active(this, this.conditional())
      }
    }
  }
</script>


// WEBPACK FOOTER //
// checkbox_page.vue?0e090ab9